import { Input, Select } from 'antd';
import { TagOutlined, UserOutlined, FlagOutlined, FileOutlined } from '@ant-design/icons';
import { STATUS_OPTIONS, KIND_OPTIONS } from './status';

interface Opt {
  value: string;
  label: string;
}

interface Props {
  categories: Opt[];
  authors: Opt[];
  /** page 類型時隱藏分類篩選（頁面無分類）。 */
  showCategory?: boolean;
  onTitle: (v: string) => void;
  onKind: (v?: string) => void;
  onCategory: (v?: string) => void;
  onAuthor: (v?: string) => void;
  onStatus: (v?: string) => void;
}

/** 文章/頁面列表的篩選工具列（包在白卡片中）。 */
export default function FilterBar({
  categories,
  authors,
  showCategory = true,
  onTitle,
  onKind,
  onCategory,
  onAuthor,
  onStatus,
}: Props) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-black/5 bg-white p-3 shadow-sm">
      <Input.Search placeholder="搜尋標題" allowClear className="w-60" onSearch={onTitle} />
      <Select
        placeholder="類型"
        allowClear
        suffixIcon={<FileOutlined />}
        className="w-28"
        onChange={onKind}
        options={KIND_OPTIONS}
      />
      {showCategory && (
        <Select
          placeholder="分類"
          allowClear
          suffixIcon={<TagOutlined />}
          className="w-36"
          onChange={onCategory}
          options={categories}
        />
      )}
      <Select
        placeholder="作者"
        allowClear
        showSearch
        optionFilterProp="label"
        suffixIcon={<UserOutlined />}
        className="w-36"
        onChange={onAuthor}
        options={authors}
      />
      <Select
        placeholder="狀態"
        allowClear
        suffixIcon={<FlagOutlined />}
        className="w-32"
        onChange={onStatus}
        options={STATUS_OPTIONS}
      />
    </div>
  );
}
